import { render, staticRenderFns } from "./BoxWrappingComponent.vue?vue&type=template&id=0224e8ad&"
import script from "./BoxWrappingComponent.vue?vue&type=script&lang=js&"
export * from "./BoxWrappingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports